import(/* webpackMode: "eager", webpackExports: ["IntegrationsGrid"] */ "/tmp/8de65cb7df521b7/components/sections/IntegrationsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65cb7df521b7/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65cb7df521b7/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65cb7df521b7/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65cb7df521b7/node_modules/next/dist/client/link.js");
